import { render, staticRenderFns } from "./Recursive.vue?vue&type=template&id=bc4677d8&scoped=true&"
import script from "./Recursive.vue?vue&type=script&lang=js&"
export * from "./Recursive.vue?vue&type=script&lang=js&"
import style0 from "./Recursive.vue?vue&type=style&index=0&id=bc4677d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4677d8",
  null
  
)

export default component.exports